import './survey-view.component.ajscss';

import { ChatSocketService } from '@agent/agent-interface/contact-view/chat/services/chat-socket.service';
import { IContactDeprecatedService } from '@agent/core/contact/contact-deprecated.service';
import { ToastDeprecatedService } from '@commons/core/notification/toast-deprecated.service';
import { IContact } from '@commons/models/contact';
import { ng1Destroy, RxUtil } from '@commons/util/utilities/rx';
import { IComponentController, IComponentOptions } from 'angular';
import { filter, of, Subscription, switchMap, withLatestFrom } from 'rxjs';

import {
  BookingFacade,
  BookingStatus,
  ChannelDirection,
  ChannelType,
  Civility,
  Configuration,
  Customer,
  CustomerAddress,
  None,
  Option,
  ToastClass,
  ToastType,
} from '@contact/upgrade';

import { SurveyType } from './models/survey';
import templateUrl from './survey-view.component.ajs.html';
import { ISurveyService } from './survey.service';

const MODULE_NAME = 'contactSurveyView';

class SurveyViewCtrl implements IComponentController {
  public name = MODULE_NAME;
  public selectedSurveyQuestionnaire: any;
  public _channelsSurveyType: string[] = [SurveyType.SMS, SurveyType.VOCAL, SurveyType.WEB, SurveyType.URL, SurveyType.CHAT];
  public _automaticSurvey: boolean = false;
  public isTriggered: boolean = false;
  closeSurvey: Function;
  triggerSurvey: Function;
  private responseId: string;
  private contactSurveyChildren: any = {};
  private selectedAddress: string = '';
  private freeAddress: string = '';
  private chooseAddress: string = '';
  private customerCivility: string = 'NOTSET';
  private customerIdSurvey: string = '';
  private selectedSurveyChannel: string = SurveyType.SMS;
  private selectedUuidSurveyQuestionnaire: string | undefined;
  private addressListOption: any[];
  private disposables: Subscription[] = [];
  private surveyQuestionnaireList: any;
  private surveysFilterByChannel: any[] = [];
  private contact: Option<IContact> = None;
  private customer: Option<Customer> = None;
  private addresses: CustomerAddress[] = [];
  private firstNameSurvey: string = '';
  private lastNameSurvey: string = '';
  private _phoneNumberValidator: RegExp;
  private _phoneNumberRegex: string =
    '^((\\+\\d{1,3}(-| )?\\(?\\d\\)?(-| )?\\d{1,3})|(\\(?\\d{2,3}\\)?))(-| )?(\\d{3,4})(-| )?(\\d{4})(( x| ext)\\d{1,5}){0,1}$';
  private _emailValidator: RegExp;
  private _emailRegex: string = '^[\\w!#$%&’*+/=?`{|}~^-]+(?:\\.[\\w!#$%&’*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$';

  constructor(
    protected readonly configuration: Configuration,
    private readonly toastDeprecatedService: ToastDeprecatedService,
    private readonly surveyService: ISurveyService,
    private readonly contactDeprecatedService: IContactDeprecatedService,
    private readonly chatSocketService: ChatSocketService,
    private readonly contactFacade: BookingFacade
  ) {}

  get isPhoneFreeNumberValid(): boolean {
    return this._phoneNumberValidator.test(this.freeAddress);
  }

  get isFreeEmailValid(): boolean {
    return this._emailValidator.test(this.freeAddress);
  }

  get showValidButton(): boolean {
    if (
      (!this.selectedAddress || this.selectedAddress === '') &&
      this.selectedSurveyChannel !== SurveyType.VOCAL &&
      this.selectedSurveyChannel !== SurveyType.CHAT
    ) {
      return false;
    } else {
      if (
        (this.selectedAddress === 'freeEntry' &&
          ((this.selectedSurveyChannel === SurveyType.SMS && !this.isPhoneFreeNumberValid) ||
            (this.selectedSurveyChannel === SurveyType.WEB && !this.isFreeEmailValid && this.chooseAddress === ''))) ||
        this.selectedUuidSurveyQuestionnaire == null ||
        this.selectedUuidSurveyQuestionnaire === '' ||
        (this.selectedAddress === 'chooseEntry' && this.chooseAddress === '')
      ) {
        return false;
      }
    }
    return true;
  }

  get contactSkills(): string[] {
    return this.contact.map(contact => contact.skills).getOrElse([]);
  }

  get contactResponseId(): string {
    return this.contact.map(contact => contact.responseId).getOrElse('');
  }

  $onInit(): void {
    this._phoneNumberValidator = new RegExp(this._phoneNumberRegex);
    this._emailValidator = new RegExp(this._emailRegex);

    this.contactFacade.selected$
      .pipe(
        ng1Destroy(this),
        filter(contact => !!contact)
      )
      .subscribe(contact => (this.contact = Option.of(contact)));

    this.contactFacade.selectedCustomer$
      .pipe(
        ng1Destroy(this),
        filter(customer => !!customer)
      )
      .subscribe(customer => (this.customer = Option.of(customer)));

    this.contactDeprecatedService.getCustomerAddresses(this.responseId).then(addresses => (this.addresses = addresses));
    this.contactSurveyChildren.updateAutomaticSurvey = this.updateAutomaticSurveyInformations.bind(this);
    this.contactSurveyChildren.updateManualSurvey = this.updateManualSurveyInformations.bind(this);
    this.contactSurveyChildren.isSurveyTriggered = this.isSurveyTriggered.bind(this);

    // event when contact is updated
    this.contactDeprecatedService
      .contactUpdated$()
      .pipe(ng1Destroy(this))
      .subscribe(contact => this.loadContactInfo(contact));

    this.contactDeprecatedService
      .contactSelected$()
      .pipe(
        switchMap(contact =>
          of({}).pipe(
            withLatestFrom(
              RxUtil.fromPromise(() => this.contactDeprecatedService.getCustomer(contact.responseId)),
              RxUtil.fromPromise(() => this.contactDeprecatedService.getCustomerAddresses(contact.responseId)),
              (_, customer, addresses) => ({
                contact,
                customer,
                addresses,
              })
            )
          )
        ),
        ng1Destroy(this)
      )
      .subscribe(({ contact, customer, addresses }) => {
        this.contact = Option.of(contact);
        this.customer = Option.of(customer);
        this.addresses = addresses;
        this.loadContactInfo(contact);
        if (this.contact.get().channel.type === ChannelType.CHAT) {
          this._channelsSurveyType = [SurveyType.SMS, SurveyType.WEB, SurveyType.URL, SurveyType.CHAT];
        } else if (this.contact.get().channel.type === ChannelType.SOCIAL_NETWORK) {
          this._channelsSurveyType = [SurveyType.SMS, SurveyType.WEB, SurveyType.URL];
        } else {
          this._channelsSurveyType = [SurveyType.SMS, SurveyType.VOCAL, SurveyType.WEB, SurveyType.URL];
        }
      });

    // contact state event
    this.contactDeprecatedService
      .contactState$()
      .pipe(
        filter(
          e =>
            e.state === BookingStatus.CLOSED && e.previousState !== BookingStatus.ACCEPTING && e.previousState !== BookingStatus.ALLOCATED
        ),
        ng1Destroy(this)
      )
      .subscribe(() => {
        if (this.selectedSurveyChannel !== SurveyType.VOCAL && this.selectedSurveyChannel !== SurveyType.CHAT) {
          this.createSurveyHistory();
        }
        this.resetSurvey();
      });
  }

  validateCustomerSurvey() {
    this.toastDeprecatedService.add(ToastType.NOTIFICATION, 'agent:panel.survey.send_survey_confirm', ToastClass.SURVEY, 4000);
    this.isTriggered = true;

    if ((this.selectedSurveyChannel === SurveyType.VOCAL || this.selectedSurveyChannel === SurveyType.CHAT) && this.contact.isDefined()) {
      const survey = this.contact.get().survey?.context;
      if (survey && this.selectedSurveyChannel === SurveyType.VOCAL) {
        survey['isVocalSurvey'] = true;
      }
      this.createSurveyHistory();
    }
  }

  createSurveyHistory() {
    if (this.isTriggered) {
      this.contact = this.contact.map(c => ({
        ...c,
        surveyContext: {
          confirmedSurvey: true,
          surveyUuid: this.selectedUuidSurveyQuestionnaire,
        },
      }));

      // Create dto to send customer information for survey history
      let surveyHistory: any = {};
      surveyHistory.surveyUuid = this.selectedUuidSurveyQuestionnaire;
      surveyHistory.channelName = this.selectedSurveyChannel;
      if (this.selectedAddress === 'freeEntry') surveyHistory.customerUri = this.freeAddress;
      else if (this.selectedAddress === 'chooseEntry') surveyHistory.customerUri = this.chooseAddress;
      else if (this.selectedSurveyChannel === SurveyType.VOCAL) surveyHistory.customerUri = this.chooseAddress;
      else surveyHistory.customerUri = this.selectedAddress;

      let phone1: string = '';
      let phone2: string = '';
      let phone3: string = '';
      let mail: string = '';

      if (this.contact.isDefined()) {
        if (this.customer.isDefined()) {
          const customerCard = this.customer.get();
          surveyHistory.customerId = customerCard.externalId;
          for (let i = 0; i < this.addresses.length; i++) {
            if (this.addresses[i].channel && this.addresses[i].uri) {
              if (this.addresses[i].channel.type === ChannelType.PHONE) {
                if (phone1 === '') phone1 = this.addresses[i].uri;
                else if (phone2 === '') phone2 = this.addresses[i].uri;
                else phone3 = this.addresses[i].uri;
              } else if (this.addresses[i].channel.type === ChannelType.MAIL) {
                mail = this.addresses[i].uri;
              }
            }
          }

          // customerCard.civility equals 0 or 1 if the agent change the civility during the call
          // customerCard.civility equals Mr or Ms if the agent does not change the civility during the call and the customer is up to date$
          let gender = Civility[this.customerCivility];
          if (gender && gender !== 'NOTSET') gender = gender.charAt(0).toUpperCase() + gender.toLowerCase().slice(1);
          else if (gender === 'NOTSET') gender = '';
          else gender = customerCard.civility.toString();

          surveyHistory.customerInfos = {
            CLIENT_SURNAME: this.firstNameSurvey,
            CLIENT_NAME: this.lastNameSurvey,
            GENDER: gender,
            PHONE1: phone1,
            PHONE2: phone2,
            PHONE3: phone3,
            EMAIL: mail,
            CLIENT_ID: this.customerIdSurvey,
          };
        }
        surveyHistory.contactConnectionId = this.contact.get().connectionId;
      }

      let response = this.surveyService.createSurveyHistory(surveyHistory);
      response.then(data => {
        const survey = this.contact.get().survey?.context;
        if (survey) {
          if (this.selectedSurveyChannel === SurveyType.VOCAL) {
            survey['vocalSessionId'] = data.surveySessionId;
          } else if (this.selectedSurveyChannel === SurveyType.CHAT) {
            survey['chatSessionId'] = data.surveySessionId;
            this.chatSocketService.sendSurveyMessage(surveyHistory.surveyUuid, data.surveySessionId);
          }
        }
      });
    }
  }

  updateSurveyChannel() {
    let customerCard = (this.customer.isDefined() && this.customer.get()) || {
      firstname: '',
      lastname: '',
      civility: '',
      externalId: '',
    };
    this.addressListOption = [];
    this.selectedAddress = '';
    this.freeAddress = (this.contact.isDefined() && this.contact.get().phoneNumber) || '';
    if (this.selectedSurveyChannel === 'WEB') this.fillFreeAddressWithMail();
    this.chooseAddress = '';
    this.firstNameSurvey = customerCard.firstname;
    this.lastNameSurvey = customerCard.lastname;
    this.customerCivility = customerCard.civility.toString();
    this.customerIdSurvey = customerCard.externalId;
    this.surveysFilterByChannel = [];
    this.selectedUuidSurveyQuestionnaire = undefined;
    if (this.surveyQuestionnaireList != null && (this.selectedSurveyChannel != null || this.selectedSurveyChannel !== '')) {
      for (let i = 0; i < this.surveyQuestionnaireList.length; i++) {
        if (this.surveyQuestionnaireList[i].surveyType !== SurveyType.URL) {
          for (let j = 0; j < this.surveyQuestionnaireList[i].channelsList.length; j++) {
            if (this.surveyQuestionnaireList[i].channelsList[j] === this.selectedSurveyChannel) {
              this.surveysFilterByChannel.push(this.surveyQuestionnaireList[i]);
            }
          }
        } else {
          if (this.selectedSurveyChannel === SurveyType.URL) {
            this.surveysFilterByChannel.push(this.surveyQuestionnaireList[i]);
          }
        }
      }
    }

    this.updateAddressListOption();
    if (this.chooseAddress === '' && this.addressListOption.length > 0) {
      this.chooseAddress = this.addressListOption[0];
    }
  }

  fillFreeAddressWithMail() {
    for (const address of this.addresses) {
      if (address.channel.type === ChannelType.MAIL) {
        this.freeAddress = address.uri;
        return;
      }
    }
  }

  updateQuestionnaire() {
    for (let i = 0; i < this.surveysFilterByChannel.length; i++) {
      if (this.surveysFilterByChannel[i].uuid === this.selectedUuidSurveyQuestionnaire) {
        this.selectedSurveyQuestionnaire = this.surveysFilterByChannel[i];
      }
    }
  }

  updateAutomaticSurveyInformations(newSurveyQuestionnnaireList) {
    this.surveysFilterByChannel = [];
    this.addressListOption = [];
    this.isTriggered = true;
    this.surveyQuestionnaireList = newSurveyQuestionnnaireList;
    this.selectedSurveyChannel = this.surveyQuestionnaireList[0].channelRandom;
    this.surveysFilterByChannel.push(this.surveyQuestionnaireList[0]);
    this.selectedUuidSurveyQuestionnaire = this.surveyQuestionnaireList[0].uuid;
    this.selectedSurveyQuestionnaire = this.surveyQuestionnaireList[0];
    this._automaticSurvey = true;

    this.updateAddressListOption();
    this.selectedAddress = this.addressListOption[0];
    let contact = this.contact.get();
    let customerCard = (this.customer.isDefined() && this.customer.get()) || { firstname: '', lastname: '' };
    this.freeAddress = (contact && contact.phoneNumber) || '';
    this.firstNameSurvey = customerCard.firstname;
    this.lastNameSurvey = customerCard.lastname;
    // since the survey is automatic, we validate it directly
    this.validateCustomerSurvey();
  }

  updateAddressListOption() {
    if (this.contact.isDefined()) {
      if (this.customer.isDefined()) {
        for (let i = 0; i < this.addresses.length; i++) {
          if (this.addresses[i].channel && this.addresses[i].channel.type && this.addresses[i].uri) {
            if (
              (this.addresses[i].channel.type === ChannelType.PHONE || this.addresses[i].channel.type === ChannelType.UNITARY_PHONE) &&
              (this.selectedSurveyChannel === SurveyType.SMS || this.selectedSurveyChannel === SurveyType.VOCAL)
            ) {
              this.addressListOption.push(this.addresses[i].uri);
            } else if (this.addresses[i].channel.type === ChannelType.MAIL && this.selectedSurveyChannel === SurveyType.WEB) {
              this.addressListOption.push(this.addresses[i].uri);
            }
          }
        }
      }
    }
  }

  updateManualSurveyInformations(newSurveyQuestionnnaireList) {
    this.surveyQuestionnaireList = newSurveyQuestionnnaireList;
    this.updateSurveyChannel();
  }

  isSurveyTriggered(): boolean {
    return this.isTriggered;
  }

  $onDestroy(): void {
    this.disposables.forEach(disposable => disposable.unsubscribe());
  }

  private resetSurvey() {
    this.isTriggered = false;
    this._automaticSurvey = false;
    this.closeSurvey();
    this.surveysFilterByChannel = [];
    this.addressListOption = [];
    this.selectedSurveyChannel = SurveyType.SMS;
    this.selectedUuidSurveyQuestionnaire = undefined;
    this.selectedAddress = '';
    this.freeAddress = '';
  }

  private loadContactInfo(updatedContact) {
    if (
      updatedContact != null &&
      !(updatedContact.channel.type === ChannelType.UNITARY_PHONE && updatedContact.channel.direction === ChannelDirection.OUTGOING)
    ) {
      this.contact = Option.of(updatedContact);
      let customer;
      if (this.contact.isDefined()) {
        customer = this.customer
          .map(({ firstname, lastname }) => ({
            firstname,
            lastname,
          }))
          .getOrElse({
            firstname: '',
            lastname: '',
          });
      } else {
        customer = { firstname: '', lastname: '' };
      }
      this.firstNameSurvey = customer.firstname;
      this.lastNameSurvey = customer.lastname;
      this.customerCivility = (customer.civility && customer.civility.toString()) || '';
      this.customerIdSurvey = customer.externalId;
    }
  }
}

export class SurveyView implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    surveyQuestionnaireList: '<',
    closeSurvey: '&',
    contactSurveyChildren: '=',
    responseId: '<',
  };
  controller = [
    'configuration',
    'toastDeprecatedService',
    'survey',
    'contactDeprecatedService',
    'chatSocketService',
    'contactFacade',
    SurveyViewCtrl,
  ];
}

export default MODULE_NAME;
